import { render, staticRenderFns } from "./AdminSbDashboard.vue?vue&type=template&id=56e237c6"
import script from "./AdminSbDashboard.vue?vue&type=script&lang=js"
export * from "./AdminSbDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports